module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-3.7bf78938.jpg";